export const clubDisplayName = "Bar Ilan University";
export const favIconUrl = "https://firebasestorage.googleapis.com/v0/b/biu-debate.appspot.com/o/biulogo.png?alt=media&token=5a0aa339-738e-4e66-82d3-0cee9edbf312";
export const clubWebsiteUrl = "https://biu-debate.firebaseapp.com/";
export const clubWebsiteUrlShort = "biu-debate.firebaseapp.com";
export const clubWebsiteUrlDomainSubstring = "biu-debate.firebaseapp.com";
export const clubFirebaseUrlDomainSubstring = "biu-debate.firebaseapp.com";
export const clubProductionServerUnsubscribe = "https://biu-debate.firebaseapp.com/unsubscribe";
export const clubStagingServerUnsubscribe = "https://biu-debate.firebaseapp.com/unsubscribe";
export const clubFacebookUrl = "https://www.facebook.com/debate.biu.club/";
export const clubLogo = "https://firebasestorage.googleapis.com/v0/b/biu-debate.appspot.com/o/biulogo.png?alt=media&token=5a0aa339-738e-4e66-82d3-0cee9edbf312";
export const clubFirebaseConfig = {
    apiKey: "AIzaSyB5lUqzKVfEqqzwQvyoCCgKFKvTmAUFR14",
    authDomain: "biu-debate.firebaseapp.com",
    projectId: "biu-debate",
    storageBucket: "biu-debate.appspot.com",
    messagingSenderId: "689761219304",
    appId: "1:689761219304:web:f22be0d3bc3a2ae43a4f5d",
    measurementId: "G-2T4CF4X7JZ"
  };
export const clubFirebaseConfigTest = {
    apiKey: "AIzaSyB5lUqzKVfEqqzwQvyoCCgKFKvTmAUFR14",
    authDomain: "biu-debate.firebaseapp.com",
    projectId: "biu-debate",
    storageBucket: "biu-debate.appspot.com",
    messagingSenderId: "689761219304",
    appId: "1:689761219304:web:f22be0d3bc3a2ae43a4f5d",
    measurementId: "G-2T4CF4X7JZ"
  };
export const clubServiceEmail = "debate.biu@gmail.com";
export const clubDisplayEmail = "debate.biu@gmail.com";